import { ThemeName, ThemeNames, isThemeName } from 'constantsValues/themeNames';
import { useContext } from 'react';
import { PageContext } from '../context/PageContext';

export const useThemeName = (): ThemeName => {
	const pageContext = useContext(PageContext);
	const themeName = pageContext?.theme;

	return isThemeName(themeName) ? themeName : ThemeNames.codan;
};
